import { emailValidation } from '../../constants/validityPatterns';

export default function validateEmail(email) {
    const pattern = emailValidation;
    return pattern.test(String(email).toLowerCase());
}